import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useLeagueLinks from "../../hooks/useLeagueLinks";
import useTeamLinks from "../../hooks/useTeamLinks";
import NavSideLeagueInfo from "./NavSideLeagueInfo";
import NavSideLinks from "./NavSideLinks";
import NavSideTeamInfo from "./NavSideTeamInfo";

const StyledNavSideContainerDiv = styled.div``;

const StyledNavSideDiv = styled.div`
  background: ${(props) => props.theme.colors.navBgSecond()};
  color: ${(props) => props.theme.colors.navColorSecond()};
  box-shadow: 0 0 20px ${(props) => props.theme.colors.boxShadow};
  height: 100vh;
  left: -30rem;
  overflow-x: hidden;
  overflow-y: scroll;
  position: absolute;
  text-transform: uppercase;
  top: 0;
  transition: left 0.2s linear;
  z-index: 100;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  &.nav__side--on {
    left: 0;
  }

  & ul.flex {
    align-items: flex-start;
    flex-flow: column wrap;
    margin: 0.75rem 0 0;
  }

  & > ul.flex {
    padding-top: 2rem;
  }

  & a {
    padding: 0.5rem;
  }

  & a:hover,
  & a:active {
    color: ${(props) => props.theme.colors.second};
  }

  & li.submenu {
    padding: 0.5rem;
  }
`;

const NavSide = ({ isOn }) => {
  const leagueLinks = useLeagueLinks();
  const teamLinks = useTeamLinks();
  const [isOnClass, setIsOnClass] = useState("nav__side--off");

  useEffect(() => {
    setIsOnClass(isOn ? "nav__side--on" : "nav__side--off");
  }, [isOn]);

  return (
    <StyledNavSideContainerDiv>
      <StyledNavSideDiv className={isOnClass}>
        <ul className={"flex " + isOnClass}>
          <li>
            <NavSideLeagueInfo />
          </li>
          <li>
            <NavSideLinks links={leagueLinks} />
          </li>
          <NavSideTeamInfo />
          <li>
            <NavSideLinks links={teamLinks} />
          </li>
        </ul>
      </StyledNavSideDiv>
    </StyledNavSideContainerDiv>
  );
};

export default NavSide;
